import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import { PAYMENT_TYPES } from "../../../utils/consts";

const PaymentTypeSelect = ({ checkedType, setCheckedType, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedType(data);
  };

  return (
    <FormControl>
      <InputLabel id="demo-simple-select-label">{t("paymentType.title")}</InputLabel>
      {/* No need to change on Autocomplete component (few options) */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={checkedType}
        onChange={handleChangeSelect}
      >
        {defaultOption && <MenuItem value={null}>{t("paymentType.all")}</MenuItem>}
        {Object.entries(PAYMENT_TYPES).map(([key, value]) => (
          <MenuItem key={key} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PaymentTypeSelect;